<!-- Admin Layout Component -->
<template>
  <div class="flex h-screen bg-gray-50">
    <!-- Sidebar Component -->
    <AdminSidebar
      :is-open="isSidebarOpen"
      :current-view="currentView"
      :menu-items="menuItems"
      @navigate="handleNavigate"
    />

    <!-- Main Content -->
    <div class="flex-1 flex flex-col overflow-hidden">
      <!-- Header Component -->
      <AdminHeader
        @toggle-sidebar="isSidebarOpen = !isSidebarOpen"
        @go-to-store="goToStore"
      />

      <!-- Page Content -->
      <main class="flex-1 overflow-y-auto p-6">
        <slot />
      </main>
    </div>

    <!-- Overlay for mobile -->
    <div
      v-if="isSidebarOpen"
      @click="isSidebarOpen = false"
      class="fixed inset-0 bg-black/50 z-40 lg:hidden"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import AdminSidebar from './AdminSidebar.vue'
import AdminHeader from './AdminHeader.vue'
import { orderService } from '@/services/orderService'

const router = useRouter()
const route = useRoute()
const isSidebarOpen = ref(false)
const notSentOrdersCount = ref(0)

const menuItems = computed(() => [
  // { 
  //   id: 'dashboard', 
  //   name: 'Dashboard',
  //   path: '/admin/dashboard',
  //   icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6'
  // },
  { 
    id: 'products', 
    name: 'Products',
    path: '/admin/products',
    icon: 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4'
  },
  { 
    id: 'orders', 
    name: 'Orders',
    path: '/admin/orders',
    icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2',
   // badge: notSentOrdersCount.value > 0 ? notSentOrdersCount.value.toString() : undefined
  },
  { 
    id: 'users', 
    name: 'Users',
    path: '/admin/users',
    icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z'
  },
 /* { 
    id: 'analytics', 
    name: 'Analytics',
    path: '/admin/analytics',
    icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z'
  },
  { 
    id: 'inventory', 
    name: 'Inventory',
    path: '/admin/inventory',
    icon: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10'
  },
  { 
    id: 'settings', 
    name: 'Settings',
    path: '/admin/settings',
    icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z'
  },*/
])

// Determinar la vista actual basada en la ruta
const currentView = computed(() => {
  const path = route.path
  if (path === '/admin' || path === '/admin/') return 'dashboard'
  const match = path.match(/^\/admin\/([^/]+)/)
  return match ? match[1] : 'dashboard'
})

const handleNavigate = (id: string) => {
  const menuItem = menuItems.value.find(item => item.id === id)
  if (menuItem) {
    router.push(menuItem.path)
  }
}

const goToStore = () => {
  router.push('/')
}

const fetchNotSentOrdersCount = async () => {
  try {
    const summary = await orderService.getNotSentSummary()
    notSentOrdersCount.value = summary.total_quantity
  } catch (error) {
    console.error('Error fetching not sent orders count:', error)
    notSentOrdersCount.value = 0
  }
}

onMounted(() => {
  fetchNotSentOrdersCount()
})
</script>
